import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { dummyProducts } from '../dummyData';
import { Star } from '@phosphor-icons/react';
import useProductList from '../../hooks/useProductList';

const TemplateYouMightLike = ({ websiteData }) => {
    const sliderRef = useRef(null);
    const { fetchProductList, data: productList } = useProductList();
    const [dataProduct, setDataProduct] = useState([]);

    useEffect(() => {
        if (websiteData?.storeId) {
            fetchProductList({
                companyId: websiteData.storeId,
                skip: 0,
                take: 20
            });
        }
    }, [websiteData?.storeId]);

    useEffect(() => {
        if (productList) {
            setDataProduct(productList);
        }
    }, [productList]);

    const displayProducts = dataProduct.length > 0 ? dataProduct : dummyProducts;
    return (
        <div className="container" style={{ marginBottom: '48px' }}>
            <div className="d-flex justify-content-between align-items-center mb-20">
                <h5 className="mb-0" style={{ fontSize: '20px', color: '#111' }}>
                    You Might Like
                </h5>
                <div className="d-flex align-items-center gap-10">
                    <Link to="/products" className="text-12 text-decoration-none d-flex align-items-center" style={{ color: '#999999' }}>
                        View All
                    </Link>
                    <div className="d-flex gap-5 d-none d-md-flex">
                        <button
                            className="btn btn-sm rounded-circle p-0 d-flex align-items-center justify-content-center"
                            style={{ width: '32px', height: '32px', backgroundColor: 'transparent', border: '1px solid #D9D9D9' }}
                            onClick={() => sliderRef.current?.slickPrev()}
                        >
                            <i className="ph ph-caret-left" style={{ fontSize: '14px', color: '#000000' }}></i>
                        </button>
                        <button
                            className="btn btn-sm rounded-circle p-0 d-flex align-items-center justify-content-center"
                            style={{ width: '32px', height: '32px', backgroundColor: 'transparent', border: '1px solid #D9D9D9' }}
                            onClick={() => sliderRef.current?.slickNext()}
                        >
                            <i className="ph ph-caret-right" style={{ fontSize: '14px', color: '#000000' }}></i>
                        </button>
                    </div>
                </div>
            </div>

            <div className="newarrivalproducts-slider" style={{ margin: '0 -8px' }}>
                <Slider
                    ref={sliderRef}
                    dots={false}
                    arrows={false}
                    infinite={displayProducts.length > 6}
                    speed={500}
                    slidesToShow={6}
                    slidesToScroll={1}
                    responsive={[
                        { breakpoint: 1200, settings: { slidesToShow: 4 } },
                        { breakpoint: 992, settings: { slidesToShow: 3 } },
                        { breakpoint: 576, settings: { slidesToShow: 2 } }
                    ]}
                >
                    {displayProducts.map((product, index) => (
                        <div key={product.id || index} className="px-10" style={{ height: '100%' }}>
                            <Link
                                to={`/product-details/${encodeURIComponent(product.slug || '-maharani-indonesian-style-dress')}`}
                                className="card h-100 overflow-hidden shadow-none text-decoration-none"
                                style={{ border: '1px solid #D9D9D9', borderRadius: '8px' }}
                            >
                                {/* Product Image */}
                                <div style={{ aspectRatio: '1/1', backgroundColor: '#FFFFFF', maxHeight: '200px' }}>
                                    <img
                                        src={
                                            product.photoData && product.photoData.length > 0
                                                ? product.photoData[0].url
                                                : '/assets/images/no-image.png'
                                        }
                                        className="w-100 h-100"
                                        style={{ objectFit: 'cover', transition: '0.2s linear' }}
                                        alt={product.name}
                                    />
                                </div>
                                {/* Product Details */}
                                <div className="p-10 d-flex flex-column" style={{ flex: 1 }}>
                                    <div className="d-flex align-items-center gap-1 text-10 mb-2">
                                        <span style={{ color: '#999999' }}>{product.rating || '4.8'}</span>
                                        <Star weight="fill" className="text-warning" size={10} />
                                        <span style={{ color: '#999999' }}>({product.reviews || '17k'})</span>
                                    </div>
                                    <h6 className="text-14 fw-medium mb-3" style={{ lineHeight: '1.4', color: '#000000' }}>
                                        {product.name}
                                    </h6>
                                    <div className="mt-auto d-flex flex-wrap align-items-center gap-1">
                                        {Number(product.discountPrice) > 0 && product.discountPrice < product.price && (
                                            <span
                                                className="text-decoration-line-through text-10 w-100 mb-1"
                                                style={{ fontSize: '10px', color: '#999999' }}
                                            >
                                                Rp{product.price?.toLocaleString()}
                                            </span>
                                        )}
                                        <div className="d-flex align-items-end gap-1">
                                            <span className="fw-bold" style={{ fontSize: '14px', lineHeight: '1', color: '#000000' }}>
                                                Rp
                                                {product.discountPrice > 0 && product.discountPrice < product.price
                                                    ? product.discountPrice?.toLocaleString()
                                                    : product.price?.toLocaleString()}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default TemplateYouMightLike;
